// import Vue from 'vue'
import Router from 'vue-router'
import mainNav from '@/components/nav/mainNav.vue'
import top from '@/views/top.vue'
const  Register = resolve => require(['@/views/register'], resolve)
import NotFound from '@/components/404.vue'
// 懒加载方式，当路由被访问的时候才加载对应组件
const Login = resolve => require(['@/views/login'], resolve)
const Vue = require('vue')
//重复点击左侧菜单 控制台报错解决方法
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location)//.catch(error=> error)
}
Vue.use(Router)

let router = new Router({
  routes: [
    // {
    //   path: '/login',
    //   type: 'login',
    //   component: Login
    // },
    // {
    //   path: '/register',
    //   type: 'register',
    //   component: Register
    // },
    {
      path: '*',
      component: NotFound
    },
    {
      path: '/',
      type: 'home', // 根据type区分不同模块（顶部导航）
      name: 'home', // 根据name区分不同子模块（左侧导航）
      redirect: '/index',
      component: top,
      menuShow: true,
      children: [
        {
          path: '/index',
          name: 'index', // 当前路由的name
          component:mainNav,
          leaf: true, // 只有一个节点
          iconCls: 'iconfont icon-home', // 图标样式class
          menuShow: true,
          children: [
            /*懒加载component: resolve=>(require(["@/components/HelloWorld"],resolve))*/
            { path: '/index', component: resolve=>(require(["@/views/index"],resolve)), name: '首页', menuShow: false },
            { path: '/ngsure', component: resolve=>(require(["@/views/ng_index"],resolve)), name: 'ngsure', menuShow: false },
            { path: '/augury', component: resolve=>(require(["@/views/au_index"],resolve)), name: 'augury', menuShow: false },
            { path: '/login', component: resolve=>(require(["@/views/login"],resolve)), name: '登录', menuShow: false },
            { path: '/register', component: resolve=>(require(["@/views/register"],resolve)), name: '注册', menuShow: false },
            { path: '/forgotPassword', component: resolve=>(require(["@/views/resetPwd"],resolve)), name: '忘记密码', menuShow: false },
            { path: '/order', component: resolve=>(require(["@/views/order_list"],resolve)), name: '我的订单', menuShow: false },
            { path: '/order/create', component: resolve=>(require(["@/views/create_order"],resolve)), name: 'createOrder', menuShow: false },
            { path: '/order/detail', component: resolve=>(require(["@/views/order_detail"],resolve)), name: 'orderDetail', menuShow: false }
          ]
        },
      ]
    },

    // {
    //   path: '/applicationManager',
    //   type: 'application',
    //   name: 'application',
    //   redirect:'/applicationManager/application/list',
    //   component:Home,
    //   menuShow: true,
    //   children: [
    //     {
    //       path: '/applicationManager/application',
    //       name: '订单管理',
    //       iconCls: 'order_left_menu',
    //       menuShow: true,
    //       children: [
    //         { path: '/applicationManager/application/list', component:resolve=>(require(["@/views/application/application_list"],resolve)), name: '生殖业务订单',menuShow: true },
    //         { path: '/applicationManager/application/create', component:resolve=>(require(["@/views/application/create_application"],resolve)), name: '生殖创建订单',menuShow: false },
    //         { path: '/applicationManager/application/detail', component:resolve=>(require(["@/views/application/application_detail"],resolve)), name: '生殖订单详情',menuShow: false },
    //         { path: '/applicationManager/application/cancer/list', component: resolve=>(require(["@/views/application/cancer/application_cancer_list"],resolve)), name: '肿瘤业务订单', menuShow: true },
    //         { path: '/applicationManager/application/cancer/create', component:resolve=>(require(["@/views/application/cancer/create_cancer_application"],resolve)), name: '创建订单',menuShow: false },
    //         { path: '/applicationManager/application/cancer/sampleDetail', component:resolve=>(require(["@/views/application/cancer/sample_cancer_detail"],resolve)), name: '肿瘤订单详情',menuShow: false },
    //         { path: '/applicationManager/application/sampleDetail', component:resolve=>(require(["@/views/sample/sample_detail"],resolve)), name: '订单详情',menuShow: false },
    //       ]
    //     },
    //   ]
    // },

  ]
});

// router.beforeEach((to, from, next) => {
//   // console.log('to:' + to.path)
//   if (to.path.startsWith('/login')) {
//     window.localStorage.removeItem('access-user')
//     next()
//   } else if(to.path.startsWith('/register')){
//     window.localStorage.removeItem('access-user')
//     next()
//   } else {
//     let user = JSON.parse(window.localStorage.getItem('access-user'))
//     if (!user) {
//       next({path: '/login'})
//     } else {
//       next()
//     }
//   }
// });

export default router



// WEBPACK FOOTER //
// ./src/router/index.js